/**
 * Order of the open overlays (dropdowns, popovers). An overlay registers itself when it opens and
 * unregisters when it closes; the last registered one is the topmost. Callers handle Escape themselves and
 * close only when `isTopmost(this)` is true, so one key press closes one overlay.
 */
class OverlayStack
{
    private readonly stack: object[] = [];

    /**
     * Registers the overlay as the topmost one. Registering an already open overlay moves it to the top.
     */
    public register(overlay: object): void {
        this.remove(overlay);
        this.stack.push(overlay);
    }

    public unregister(overlay: object): void {
        this.remove(overlay);
    }

    public isTopmost(overlay: object): boolean {
        return this.stack.length > 0 && this.stack[this.stack.length - 1] === overlay;
    }

    private remove(overlay: object): void {
        const index = this.stack.indexOf(overlay);
        if (index !== -1) {
            this.stack.splice(index, 1);
        }
    }
}

const overlayStack = new OverlayStack();

export default overlayStack;
